import {
  Box,
  FormControlLabel,
  Paper,
  Switch,
  TextField,
  Button,
  IconButton,
  CircularProgress,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useState } from 'react';
import ApiService from '../../../functions/apiService';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';

const formatDate = (time) => moment(time, 'HH:mm:ss').format('hA');

export const RotationForm = ({
  register,
  errors,
  setValue,
  watch,
  user
}) => {
  const [params] = useSearchParams();
  const empId = params.get('empId');
  const isRotationActive = watch('Unique_Rotation');
  const [effectiveDate, setEffectiveDate] = useState(
    new Date().toISOString().split('T')[0]
  );
  const [days, setDays] = useState([{ value: [] }]);
  const [shiftTypes, setShiftTypes] = useState([]);
  const [isShiftTypesLoading, setIsShiftTypesLoading] = useState(false);

  const toggleRotation = (e) => setValue('Unique_Rotation', e.target.checked);

  const onDateChange = (e) => {
    setEffectiveDate(e.target.value);
    setValue('Rot_Effective_Date', e.target.value);
  };

  const handleDayChange = (index, newValue) => {
    setDays((prev) => {
      const updatedValue = prev.map((day, i) =>
				i === index ? {value: newValue } : day
      );
      setValue(
        'Rotation',
        `${updatedValue.map((item) => item.value.join('')).join(',')}`,
        { shouldDirty: true }
      );
      return updatedValue;
    });
  };

  const handleAddDay = () => {
    setDays((prev) => [...prev, { value: [] }]);
  };

  const handleDeleteDay = (index) => {
    setDays((prev) => prev.filter((_, i) => i !== index));
    setValue(
      'Rotation',
      `${days
        .map((item) => item.value)
        .filter((_, i) => i !== index)
        .join(',')}`
    );
  };

  useEffect(() => {
    setValue('Rot_Effective_Date', effectiveDate);

    const getShiftTypes = async () => {
      try {
        setIsShiftTypesLoading(true);
        const { data } = await ApiService.get('/shiftTypes', {
          date: effectiveDate,
        });
        setShiftTypes(
          data.data.map((item) => ({
            shiftCode: item.ShiftCode,
            shiftHours: item.Shift_Hours,
            shiftName: item.Shift,
            shiftStart: item.Start_Time,
            shiftEnd: item.End_Time,
          }))
        );
        setIsShiftTypesLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    getShiftTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { 
		if(!user) return;
    const currentEmployee = user.employee_rotation

    if(!currentEmployee) return

    setValue('Rot_Effective_Date', currentEmployee.Effective_Date || effectiveDate);
    setValue('Unique_Rotation', true);

    setDays(currentEmployee.Rotation.split(',').map((item) => ({ value: item.split('') })));
		
	}, [user])

  return (
    <Paper className="p-4 my-3">
      <p className="fw-500 fs-5">Rotation</p>
      {isShiftTypesLoading ? (
        <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControlLabel
            control={
              <Switch
                onChange={toggleRotation}
                checked={isRotationActive}
                {...register('Unique_Rotation')}
              />
            }
            label="Activate Rotation"
          />

          <Box>
            <TextField
              color="secondary"
              type="date"
              variant="outlined"
              label="Effective Date"
              disabled={!isRotationActive}
              {...register('Rot_Effective_Date', {
                required: 'Effective Date is required',
                onChange: onDateChange,
              })}
            />
            {errors.Rot_Effective_Date && (
              <p style={{ color: 'red' }}>
                {errors.Rot_Effective_Date?.message}
              </p>
            )}
          </Box>
          {days.map((day, index) => (
            <Box
              key={index}
              sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <FormControl fullWidth>
                <InputLabel>{`Day ${index + 1}`}</InputLabel>
                <Select
                  label={`Day ${index + 1}`}
                  value={day.value}
                  onChange={(e) => handleDayChange(index, e.target.value)}
                  disabled={!isRotationActive}
									multiple
                >
                  {shiftTypes.map((shift) => (
                    <MenuItem key={shift.shiftCode} value={String(shift.shiftCode)}>

                      {`(${formatDate(shift.shiftStart)} - ${formatDate(shift.shiftEnd)})`}
                    </MenuItem>
                  ))}
                  <MenuItem value="X">Not Working</MenuItem>
                </Select>
              </FormControl>
              <IconButton
                onClick={() => handleDeleteDay(index)}
                disabled={!isRotationActive || days.length === 1}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}

          <Button
            variant="outlined"
            color="primary"
            onClick={handleAddDay}
            disabled={!isRotationActive}
          >
            + Add
          </Button>
        </Box>
      )}
    </Paper>
  );
};
